module.exports = __webpack_public_path__ + "img/pencil-room-icon.d7df6780.svg";